import ApolloManager from '../utils/ApolloManager';
import { gql } from '@apollo/client';
import storage from '../../storage';
import { gqlUser } from '../gql/user';
import { gqlConstants } from '../gql/constants';

class AuthService {
  login = (companyCode, personalCode, password, from = '') => new Promise((resolve, reject) => {
    // クエリを定義
    const LOGIN_MUTATION = gql`
      mutation login ($input: loginInput!) {
        login (input: $input) {
          user {
            ...${gqlUser.name}
          }
          constants {
            ...${gqlConstants.name}
          }
          token
          error
          mfaToken
          mfaStatus
          mfaSecret
          mfaQrCode
        }
      }
      ${gqlUser.fragment}
      ${gqlConstants.fragment}
    `;

    ApolloManager.getInstance().client.mutate({
      variables: {
        input: {
          companyCode: companyCode,
          personalCode: personalCode,
          password: password,
          from: from
        }
      },
      mutation: LOGIN_MUTATION,
    })
    .then((result) => {
      // 2段階認証が必要な場合は token が返らないので、loginMfa でコードを送るまで保存しない
      if (result.data.login.token) {
        storage.setSession(result.data.login.token);
        storage.setUser(result.data.login.user);
        storage.setConstants(result.data.login.constants);
      }
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
  })

  // 2段階認証のコード入力（login で mfaToken を受け取った後）
  loginMfa = (mfaToken, code) => new Promise((resolve, reject) => {
    const LOGIN_MFA_MUTATION = gql`
      mutation loginMfa ($input: loginMfaInput!) {
        loginMfa (input: $input) {
          user {
            ...${gqlUser.name}
          }
          constants {
            ...${gqlConstants.name}
          }
          token
          error
        }
      }
      ${gqlUser.fragment}
      ${gqlConstants.fragment}
    `;

    ApolloManager.getInstance().client.mutate({
      variables: {
        input: {
          mfaToken: mfaToken,
          code: code
        }
      },
      mutation: LOGIN_MFA_MUTATION,
    })
    .then((result) => {
      storage.setSession(result.data.loginMfa.token);
      storage.setUser(result.data.loginMfa.user);
      storage.setConstants(result.data.loginMfa.constants);
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
  })

  // from: 'pc'（管理画面）の場合、2段階認証が必要な権限は2段階認証済みのトークンでないと更新できない
  updateToken = (from = '') => new Promise((resolve, reject) => {
    // クエリを定義
    const UPDATE_TOKEN_MUTATION = gql`
      mutation updateToken ($input: updateTokenInput!) {
        updateToken (input: $input) {
          user {
            ...${gqlUser.name}
          }
          constants {
            ...${gqlConstants.name}
          }
          token
          error
        }
      }
      ${gqlUser.fragment}
      ${gqlConstants.fragment}
    `;

    ApolloManager.getInstance().client.mutate({
      variables: {
        input: {
          token: storage.getSession(),
          from: from
        }
      },
      mutation: UPDATE_TOKEN_MUTATION,
    })
    .then((result) => {
      storage.setUser(result.data.updateToken.user);
      storage.setSession(result.data.updateToken.token);
      storage.setConstants(result.data.updateToken.constants);
      resolve(result.data);
    })
    .catch((error) => {
      reject(error);
    });
  })
}

const authService = new AuthService();

export default authService;